import { AppleApplication } from '@rocksoft/mdm-sdk-v2';

import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

export interface AppleApplicationState extends EntityState<AppleApplication> {
  progress: number | null;
}

export function selectId(application: AppleApplication) {
  return `${application.bundleIdentifier}-${application.bundleVersion}`;
}

export const adapter: EntityAdapter<AppleApplication> = createEntityAdapter<AppleApplication>({
  selectId: selectId,
});

export const initialState: AppleApplicationState = adapter.getInitialState({
  progress: null,
});
